"use strict";

var _classCallCheck = require("/root/website/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simulation = void 0;

var Simulation = function Simulation(_ref) {
  var interestRateMonthly = _ref.interestRateMonthly,
      installmentsQuantity = _ref.installmentsQuantity,
      installmentsAmount = _ref.installmentsAmount;

  _classCallCheck(this, Simulation);

  this.interestRateMonthly = interestRateMonthly;
  this.installmentsQuantity = installmentsQuantity;
  this.installmentsAmount = installmentsAmount;
};

exports.Simulation = Simulation;